<template>
  <section class="my-information__content">
    <header class="content__header">
      <h2>{{ $t('userInfo.lnb.myInformation') }}</h2>
    </header>
    <transition name="deactivate">
      <edit-information :key="refreshKey" v-if="!applyWithdraw"
                        @applyWithdraw="applyWithdraw = true"
                        @reload="reload" />
      <deactivate-info v-else
                       @closeWithdraw="applyWithdraw = false"/>
    </transition>
  </section>
</template>

<script>
import EditInformation from '@/components/user-info/my-information/EditInformation'
import DeactivateInfo from '@/components/user-info/my-information/DeactivateInfo'

export default {
  components: {
    EditInformation,
    DeactivateInfo
  },
  data () {
    return {
      refreshKey: 0,
      applyWithdraw: false
    }
  },
  methods: {
    reload () {
      this.refreshKey++
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.my-information__content {
  position: relative;
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;

  .content__header {
    font-size: 26px;
    font-weight: 600;
    color: #444444;
    margin-left: 30px;
    margin-right: 30px;
    padding-bottom: 22px;
    border-bottom: 1px solid #d7d7d7;

    h2 {
      padding-left: 10px;
    }
  }

  .deactivate-enter-active,
  .deactivate-leave-active {
    transition: opacity 0.5s ease, top 0.5s ease;
    opacity: 1;
    position: absolute;
    top: 89px;
    left: 50%;
    width: calc(100% - 60px);
    transform: translateX(-50%);
  }

  .deactivate-enter,
  .deactivate-leave-to {
    opacity: 0;
  }

  .deactivate-enter {
    top: 119px;
  }
}
</style>
